/**
 * Drop cached data whenever the signed-in account changes.
 *
 * A static SPA never reloads across a sign-in, so without this a second person signing in on the
 * same tab would briefly see whatever the first one loaded. The SDK emits no session-change event
 * (greenbook FRICTION.md, 2026-09-09), so we watch our own auth store. A silent key refresh keeps
 * the same installId and does not wipe.
 */
import { identity, subscribeAuth } from "./omauth";
import { queryClient } from "./queryClient";

export function installSessionGuard(): () => void {
  let owner = identity();
  return subscribeAuth(() => {
    const next = identity();
    if (next === owner) return;
    owner = next;
    void queryClient.cancelQueries();
    queryClient.clear();
  });
}
